import DragHandle from 'nucleus-core/containers/DragHandle.js';
import Icon from '@cvent/nucleus-icon';
import InteractiveElement from 'nucleus-core/containers/InteractiveElement';
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { tapOrClick } from 'nucleus-core/touchEventHandlers';
import { resolveTestId, injectTestId } from '@cvent/nucleus-test-automation';

export default class DialogHeader extends React.Component {
  static propTypes = {
    text: PropTypes.string,
    onClose: PropTypes.func,
    closeFallbackText: PropTypes.string,
    classes: PropTypes.object,
    style: PropTypes.object
  }
  handleClose = (event) => {
    event.preventDefault();
    const { onClose } = this.props;
    if (onClose) { onClose(); }
  }
  render() {
    const { text, onClose, closeFallbackText, classes, style } = this.props;
    return (
      <DragHandle classes={classes} style={style} aria-describedby="dialogHeader">
        <h2 {...resolve(this.props, 'dialogHeader')} {...resolveTestId(this.props)} id="dialogHeader">
          {text}
          {onClose &&
            <InteractiveElement
              {...resolve(this.props, 'closeDialog')}
              {...injectTestId('close')}
              onClick={this.handleClose}
              {...tapOrClick(this.selectItem)}
            >
              <Icon icon="closeDeleteFilled" fallbackText={closeFallbackText} />
            </InteractiveElement>}
        </h2>
      </DragHandle>
    );
  }
}
